import React, { useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import VickChatPanel from './VickChatPanel';
import { useContagemAlertasNaoLidos } from '../../hooks/useIaAlertas';

const VickLauncherButton: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const naoLidos = useContagemAlertasNaoLidos();

    return (
        <>
            <button
                onClick={() => setIsOpen(prev => !prev)}
                title={isOpen ? 'Fechar chat' : 'Falar com a Vick'}
                // No celular o botão flutuante cobre o conteúdo — some abaixo de md
                // (mesmo corte da barra de navegação inferior). A Vick segue em /vick.
                className="fixed bottom-5 left-5 z-[152] w-14 h-14 rounded-full bg-gradient-to-br from-primary to-primary/80 text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all hidden md:flex items-center justify-center"
            >
                {isOpen ? <X size={24} /> : <Sparkles size={24} />}
                {/* O contador é o que torna a Vick proativa de fato: sem ele, ela
                    só avisa quem abre o painel, e aí não avisou nada.

                    Conta só o NÃO LIDO, e some quando zera. Badge é chamado de
                    atenção — depois de lido não há o que chamar, e uma bolinha
                    permanente vira parte do cenário (o alerta agregado de saldo
                    fica aberto por semanas). O tamanho da fila continua na aba
                    Alertas, que é onde ele serve de informação e não de alarme. */}
                {!isOpen && naoLidos > 0 ? (
                    <span
                        aria-label={`${naoLidos} alerta(s) novo(s)`}
                        className="absolute -top-0.5 -right-0.5 min-w-[22px] h-[22px] px-1 bg-red-500 text-white text-[11px] font-bold rounded-full border-2 border-white dark:border-slate-900 flex items-center justify-center"
                    >
                        {naoLidos > 99 ? '99+' : naoLidos}
                    </span>
                ) : null}
            </button>
            <VickChatPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </>
    );
};

export default VickLauncherButton;
